import {HotelList} from "components/front/PMS/Hotel/List/HotelList"
import React from "react"

export const HotelListRoute = (props: any) => {
  return <div>
    <h1>Liste des Hotels</h1>
    <HotelList />
  </div>
}